import React, { useEffect, useState } from 'react';
import './LandingPage.css';
import MenuCard from './MenuCard';
import hrmsLogo from './HRMS.png';
import StoreLogo from './Store.png';
import billingIcon from './Billing.png';
import PNMLogo from './PNM.png';
import accountingIcon from './Accounts.png';
import { useLocation, useNavigate } from 'react-router-dom';
import { service } from '../services/service';
import AppBar from './AppBar';

const LandingPage = () => {
  const menuItems = [
    {
      title: 'HRMS',
      icon: hrmsLogo,
      id: 'hrms'
    },
    {
      title: 'P&M',
      icon: PNMLogo,
      id: 'pm'
    },
    {
      title: 'Planning & Billing',
      icon: billingIcon,
      id: 'planning-billing'
    },
    {
      title: 'Store',
      icon: StoreLogo,
      id: 'store'
    },
    {
      title: 'Accounting',
      icon: accountingIcon,
      id: 'accounting'
    }
  ];

  const location = useLocation()
  const navigate = useNavigate()

  const [moduleData, setModuleData] = useState([])
  const [forwardUrl, setForwardUrl] = useState("")

  const handleLogout = () => {

    console.log("SKLDAKSLJDLASJKD", 123);
    localStorage.removeItem("companyToken")
    window.location.href = `/`

  }

  useEffect(() => {
    if (localStorage.getItem("companyToken")) {
      return
    }
    else {
      navigate("/")
    }
  }, [])


  const token = localStorage.getItem("companyToken")


  useEffect(() => {

    const queryParams = new URLSearchParams(location.search);
    const token = queryParams.get('token');
    const forwardUrl = queryParams.get('forwardUrl');
    setForwardUrl(forwardUrl)
    console.log("ASDKHASKHDKASHD", forwardUrl, location?.state?.loginUrl);
    if (!token) {
      localStorage.removeItem("companyToken")
      navigate("/")
    }

  }, [])

  useEffect(() => {
    let apiEndpoint = `employee_master/employee/getAllModulesByCompanyId`;
    service.getAllModules(apiEndpoint).then(
      res => {
        if (res?.data?.status === 200) {
          console.log("ASDKJAHSKDHASKDHASKJDH", res?.data?.data);
          let Arr=res?.data?.data?.filter((val)=> val?.isActive==true)
          setModuleData(Arr)
        }
        else {
          setModuleData([])
        }

      }
    ).catch(err => console.log("ASDLAJKSDAHSKAHD", err))
  }, [])


  const handleRedirectToModule=(ele)=>{
    const url=`${ele?.redirectionURL}?token=${token}&forwardUrl=${location?.state?.loginUrl || forwardUrl ||""}`
    window.open(url,"_self")
  }

  return (


    <>
    
      <div className="landing-container">
        <div className="background-overlay"></div>
        <AppBar location={location} handleLogout={handleLogout} />
        <div className="content">
          <div className="header">
            <h1>Welcome to NYGGS!</h1>
            <h2>How would you like to continue?</h2>
          </div>
          <div className="menu-cards">
            {moduleData?.map((item) => (
              <MenuCard
                key={item?.id}
                title={item?.name}
                icon={item?.logo}
                id={item?.id}
                value={item}
                handleRedirectToModule={handleRedirectToModule}
              />
            ))}
          </div>
        </div>
      </div>
    </>

  );
};

export default LandingPage;